<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div class="flex gap-2 bg-white items-center">
      <img src="../../assets/image/search.svg" alt="" class="" />
      <input
        [placeholder]="'Search Name  Here...'"
        (keyup)="onKeyUp($event, pagination)"
        class="w-full border p-2 rounded-md outline-none"
      />
      <select *ngIf="userRole=='admin' ||userRole=='partner' "
      class="w-32 border p-2 rounded-xl bg-gradient-to-r from-primary to-semiPrimary text-white text-white"
      [value]=""
      (change)="getRoleViaSearch($event, pagination)"
    >
      <option value="reseller,merchant" class="bg-white text-primary">All</option>
      <option value="reseller" class="bg-white text-primary">Reseller</option>
      <option value="merchant" class="bg-white text-primary">Merchant</option>

   
    </select>
      <!-- <select class="w-80 border p-2 rounded-xl outline-none" (change)="getAllProviderViaFilter($event)">
        <option value="">Select Filter</option>
        <option value="PayIn">Pay In</option>
        <option value="PayOut">Pay Out</option>
      
        <option value="PayIn/PayOut">PayIn/PayOut</option>
      </select> -->

      <!-- <div class="flex-none">
        <app-primary-button (click)="openToCreate()">
          <div class="flex gap-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            Add Provider
          </div></app-primary-button
        >
      </div> -->
    </div>
  </div>
  <div class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-auto">
    <table class="w-full text-left p-2">
      <tr class="p-2 border-[3px] border-transparent border-b-gray-300">
        <th class="text-nowrap pl-3">Sr. No</th>
        <!-- <th class="p-2">User ID</th> -->
        <th class="px-4 text-nowrap">Name</th>
        <th class="px-4 text-nowrap">Onboarded By</th>
        <th *ngIf="userRole == 'admin'" class="px-4 text-nowrap">
          Vendor Name
        </th>
        <!-- <th class="px-4 text-nowrap">Buiness Name</th> -->
        <th class="px-4 text-nowrap">Type</th>
        
        <th class="px-4 text-nowrap">Phone Number</th>
        <th class="px-4 text-nowrap">Email</th>

        <th
          class=" text-nowrap"
          *ngIf="permissions.includes('customer-profile-edit')"
        >
          Edit
        </th>
      </tr>

      <tr
        *ngFor="let items of customerData; let i = index"
        [ngStyle]="{
          backgroundColor:
            i % 2 == 0
              ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
              : 'white'
        }"
        class="p-2"
      >
        <td class="p-3">{{ i + 1 + (pagination.currentPage - 1) * 10 }}</td>
        <!-- <td class="">
            <div>{{ items._id }}</div>
          </td> -->
        <td class="px-4">
          <div (click)="toggleView(items._id)" class="cursor-pointer">
            {{ items.name | titlecase }}
          </div>
        </td>
        <td class="px-4">
          {{items?.createdBy?.name | titlecase}}
          </td>
        <td *ngIf="userRole == 'admin'" class="px-4">
          <div>{{ items.businessName | titlecase }}</div>
        </td>
        <td class="px-4">
          <div>{{ items?.role?.title | titlecase }}</div>
        </td>
      
        <td class="px-4">
          {{ items.phone }}
        </td>
        <td class="px-4">
          {{ items.email }}
        </td>

        <!-- <td style="background-color: rgb(18, 199, 28);">
            <div>{{ items.logo }}</div>
          </td> -->
        <td class=""
          (click)="routeToCustomerDetails(items._id)"
          *ngIf="permissions.includes('customer-profile-edit')"
        >
          <img class="px-5" src="../../assets/image/edit.svg" alt="" class="w-25" />
        </td>
      </tr>
    </table>
    <app-empty-data
      *ngIf="customerData?.length < 1"
      class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/service_request.png'"
      [message]="'No data available'"
    ></app-empty-data>
  </div>
  <app-next-preview-button
    [limit]="pagination.limit"
    [currentPage]="pagination.currentPage"
    [totalPage]="totalPage"
    [totalRecords]="totalRecords"
    (next)="nextPage()"
    (previous)="previousPage()"
    (pageChange)="onPageChange($event)"
    (last)="onLast()"
    (first)="onFirst()"
  ></app-next-preview-button>
</div>
